import { Backup } from '@components/icons'
import SurfaceDetailsModalButton from '@components/product/SurfaceDetailsModalButton'
import { useUI } from '@components/ui'
import cn from 'clsx'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface props {
  surfaceArea: number
  setSurfaceArea: (area: number) => void
  setNumberOfCoats: (numberOfCoats: string) => void
  prismicContent: any
  showSurfaceSelectionTitle?: boolean
  selectedBgWhite?: boolean
}

const ProductSurfaceSelection: FC<props> = ({
  surfaceArea,
  setSurfaceArea,
  prismicContent,
  setNumberOfCoats,
  showSurfaceSelectionTitle = true,
  selectedBgWhite = false,
}) => {
  const {
    setSelectedSurfaceRequiresPrepCoatUpsell,
    openCalculator,
    setSelectedSurfaceTitle,
    selectedSurfaceIndex,
    setSelectedSurfaceIndex,
  } = useUI()
  const { t } = useTranslation('product')
  const { surfaceSelectionTitle, slices } = prismicContent || {}
  // const [selectedSurfaceIndex, setSelectedSurfaceIndex] = useState(
  //   surfaceArea > 0
  //     ? slices.findIndex((s: any) => s.primary.areaRatio === surfaceArea)
  //     : -1
  // )

  const resetSurfaceSelection = () => {
    setSelectedSurfaceIndex(-1)
    setSurfaceArea(0)
    setNumberOfCoats('two')
    setSelectedSurfaceRequiresPrepCoatUpsell(false)
    setSelectedSurfaceTitle('')
  }

  return (
    <div className="flex flex-col">
      <div>
        {showSurfaceSelectionTitle ? (
          <div className="flex items-center justify-between">
            {surfaceSelectionTitle && (
              <div className="body-1-bold text-ui-dark-grey">
                {surfaceSelectionTitle}
              </div>
            )}
            <button className="mx-auto flex justify-center gap-1.5 outline-none focus:outline-none">
              <SurfaceDetailsModalButton prismicContent={prismicContent} />
            </button>
          </div>
        ) : null}

        {slices && (
          <div className="mt-6 md:mt-10">
            {slices.map((surface: any, index: number) => {
              const {
                areaRatio,
                numberOfCoats,
                helperModalTitle,
                requiredPrepCoatUpsell,
                text,
              } = surface.primary
              const selectSurface = () => {
                setSelectedSurfaceIndex(index)
                setSurfaceArea(areaRatio)
                setNumberOfCoats(numberOfCoats)
                setSelectedSurfaceRequiresPrepCoatUpsell(requiredPrepCoatUpsell)
                setSelectedSurfaceTitle(helperModalTitle)
                openCalculator(0)
              }

              if (selectedSurfaceIndex > -1 && selectedSurfaceIndex !== index)
                return null

              return (
                <div key={`surface-${index}`} id={`surface-${index}`}>
                  {text && (
                    <button
                      className={cn(
                        'body-1 mb-2 w-full rounded-sm border bg-white p-4 text-left text-ui-dark-grey outline-none',
                        {
                          'border-ui-dark-grey bg-ui-light-grey':
                            selectedSurfaceIndex === index && !selectedBgWhite,
                          'border-ui-dark-grey bg-primary':
                            selectedSurfaceIndex === index && selectedBgWhite,
                          'border-ui-grey-25': selectedSurfaceIndex !== index,
                        }
                      )}
                      onClick={selectSurface}
                    >
                      {text}
                    </button>
                  )}
                </div>
              )
            })}
          </div>
        )}

        {selectedSurfaceIndex > -1 ? (
          <>
            <button
              type="button"
              onClick={resetSurfaceSelection}
              className="body-2 mt-1 flex items-center gap-1 underline"
            >
              <Backup />
              <span>{t('select-a-different-surface')}</span>
            </button>
          </>
        ) : null}
      </div>
    </div>
  )
}

export default ProductSurfaceSelection
